<h2 mat-dialog-title>Reset password</h2>
<ng-container *ngIf="passwordState | async as state">

  <mat-dialog-content>
    <ng-container *ngIf="state == 'INIT'">
      Are you sure you want to reset the password for <b>{{ user.email }}</b>?
    </ng-container>

    <ng-container *ngIf="state == 'RESETTING'">
      Resetting password, please wait...
    </ng-container>

    <ng-container *ngIf="state == 'RESET'">
      Password was reset for <b>{{ user.email }}</b>. <br>
      New password: <b>{{ newPassword }}</b>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="copyPassword()" *ngIf="state == 'RESET'">Copy</button>
    <button mat-raised-button (click)="confirmPasswordReset()" *ngIf="state == 'INIT'">Yes</button>
    <button mat-raised-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>

</ng-container>
